import { useGSAP } from "@gsap/react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export const useScrolltriggerClassnames = (selector = "[data-transition='addclass']", dependencies = []) => {
  useGSAP(
    () => {
      const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      gsap.config({
        autoSleep: 60,
      });
      ScrollTrigger.batch(selector, {
        start: "top 105%",
        end: "top 100%-=25px",
        invalidateOnRefresh: true,
        onLeave: (elements) => {
          elements.forEach((el, index) => {
            elements[index].classList.add("activeElement");
          });
        },
      });
      ScrollTrigger.config({ ignoreMobileResize: true });
    },
    { dependencies }
  );
};
